import { IotsUptimeMetricChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast7DaysHardwareIotsUptimeMetricChart } from './use-last-7-days-hardware-iots-uptime-metric-chart';

export interface Last7DaysHardwareIotsUptimeMetricChartProps {
    accountId: string;
}

export const Last7DaysHardwareIotsUptimeMetricChart = ({ accountId }: Last7DaysHardwareIotsUptimeMetricChartProps) => {
    const { data, isLoading, hasData } = useLast7DaysHardwareIotsUptimeMetricChart({ accountId });

    return (
        <StatisticsCard
            chartKey={IotsUptimeMetricChart.definition.key}
            compact
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.last-7-days-hardware-iots-uptime-metric-chart.title'
                    description='Title of the hardware dashboard card showing average IoT uptime over the last 7 days'
                    defaultMessage='Uptime'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.statistics.hardware.last-7-days-hardware-iots-uptime-metric-chart.subtitle'
                    description='Subtitle of the hardware dashboard uptime metric card indicating the last 7 days window'
                    defaultMessage='Last 7 days'
                />
            }
            isLoading={isLoading}
            hasData={hasData}>
            {data && (
                <div className='mt-auto w-full'>
                    <IotsUptimeMetricChart data={data} />
                </div>
            )}
        </StatisticsCard>
    );
};
